"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.appendSetCookieHeadersToNextApiResponse = void 0;
const cookie_1 = require("../../utils/cookie");
const appendSetCookieHeadersToNextApiResponse = (response, cookies, setCookieOptions) => {
    for (const { name, value } of cookies) {
        response.appendHeader('Set-Cookie', (0, cookie_1.serializeCookie)(name, value, setCookieOptions));
    }
};
exports.appendSetCookieHeadersToNextApiResponse = appendSetCookieHeadersToNextApiResponse;
